export default __webpack_public_path__ + "static/media/padellogo2.95e1dcdb.svg";